import { DEFAULT_SETTINGS, type AppSettings } from '../run/types';

const SETTINGS_KEY = 'gauntle-unlimited:settings:v1';

export function loadSettings(): AppSettings {
  try {
    const stored = localStorage.getItem(SETTINGS_KEY);
    if (!stored) return DEFAULT_SETTINGS;
    const value = JSON.parse(stored) as Partial<AppSettings>;
    return {
      mode: value.mode === 'competitive' ? 'competitive' : 'practice',
      sound: value.sound ?? DEFAULT_SETTINGS.sound,
      reducedMotion: value.reducedMotion ?? DEFAULT_SETTINGS.reducedMotion,
    };
  } catch {
    return DEFAULT_SETTINGS;
  }
}

export function saveSettings(settings: AppSettings) {
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
}
